import React from 'react';

import Spinner from '../Spinner/index.jsx';

import BEM from '../../Utilities/BEM/index.jsx';


class LoadingOverlay extends React.Component {
  render() {
    var variants = [];

    if (this.props.disabled) {
      variants.push('disabled');
    }

    return (
      <div className={BEM.classString('cs-loading-overlay', variants)}>
        <div className="cs-loading-overlay__content">
          {this.props.children}
        </div>
        <div className="cs-loading-overlay__spinner">
          <Spinner />
        </div>
      </div>
    );
  }
}

export default LoadingOverlay;

